import create from 'antd/lib/icon/IconFont'
import { createTypes, createAction } from 'lib/action'
const BEGINING_STOCK_LOAD_DIVISION = createTypes(
  'beginingStockLoadDivision',
  'load'
)
const BEGINING_STOCK_LOAD_DEPARTMENT = createTypes(
  'beginingStockLoadDepartment',
  'load'
)
const BEGINING_STOCK_LOAD_SECTION = createTypes(
  'beginingStockLoadSection',
  'load'
)
const BEGINING_STOCK_LOAD_PLANT = createTypes('beginingStockLoadPlant', 'load')

const BEGINING_STOCK_LOAD_DATASOURCE_FOR_TABLE = createTypes(
  'beginingStockLoadDataSourceForTable',
  'load'
)

const BEGINING_STOCK_REMOVE_LISTS = `REMOVE_LISTS`

const UPDATE_BEGINING_STOCK_DATASOURE_FOR_TABLE = createTypes(
  'beginingStockUpdateDataSourceForTable',
  'update'
)

const BEGINING_STOCK_LOAD_ERROR = createTypes('beginingStockLoadError', 'load')

const BEGINNING_STOCK_EXPORT = createTypes('beginningStockExport', 'load')

const beginingStockLoadError = {
  request: (data, loading) =>
    createAction(BEGINING_STOCK_LOAD_ERROR.REQUEST, { data, loading }),
  success: (lists) =>
    createAction(BEGINING_STOCK_LOAD_ERROR.SUCCESS, { lists }),
  failure: () => createAction(BEGINING_STOCK_LOAD_ERROR.FAILURE),
}

// *load division
const beginingStockLoadDivision = {
  request: (data, loading) =>
    createAction(BEGINING_STOCK_LOAD_DIVISION.REQUEST, { data, loading }),
  success: (lists) =>
    createAction(BEGINING_STOCK_LOAD_DIVISION.SUCCESS, { lists }),
  failure: () => createAction(BEGINING_STOCK_LOAD_DIVISION.FAILURE),
}
// *load department
const beginingStockLoadDepartment = {
  request: (data, loading) =>
    createAction(BEGINING_STOCK_LOAD_DEPARTMENT.REQUEST, { data, loading }),
  success: (lists) =>
    createAction(BEGINING_STOCK_LOAD_DEPARTMENT.SUCCESS, { lists }),
  failure: () => createAction(BEGINING_STOCK_LOAD_DEPARTMENT.FAILURE),
}
// *load section
const beginingStockLoadSection = {
  request: (data, loading) =>
    createAction(BEGINING_STOCK_LOAD_SECTION.REQUEST, { data, loading }),
  success: (lists) =>
    createAction(BEGINING_STOCK_LOAD_SECTION.SUCCESS, { lists }),
  failure: () => createAction(BEGINING_STOCK_LOAD_SECTION.FAILURE),
}
// *load plant
const beginingStockLoadPlant = {
  request: (data, loading) =>
    createAction(BEGINING_STOCK_LOAD_PLANT.REQUEST, { data, loading }),
  success: (lists) =>
    createAction(BEGINING_STOCK_LOAD_PLANT.SUCCESS, { lists }),
  failure: () => createAction(BEGINING_STOCK_LOAD_PLANT.FAILURE),
}

// *load data source for table
const beginingStockLoadDataSourceForTable = {
  request: (data, loading) =>
    createAction(BEGINING_STOCK_LOAD_DATASOURCE_FOR_TABLE.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(BEGINING_STOCK_LOAD_DATASOURCE_FOR_TABLE.SUCCESS, { lists }),
  failure: () =>
    createAction(BEGINING_STOCK_LOAD_DATASOURCE_FOR_TABLE.FAILURE),
}

// *update data source for table
const beginingStockUpdateDataSourceForTable = {
  request: (data, loading) =>
    createAction(UPDATE_BEGINING_STOCK_DATASOURE_FOR_TABLE.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(UPDATE_BEGINING_STOCK_DATASOURE_FOR_TABLE.SUCCESS, { lists }),
  failure: () =>
    createAction(UPDATE_BEGINING_STOCK_DATASOURE_FOR_TABLE.FAILURE),
}

// *export ข้อมูล
const beginingStockExport = {
  request: (data, loading) =>
    createAction(BEGINNING_STOCK_EXPORT.REQUEST, {
      data,
      loading,
    }),
  success: (lists) => createAction(BEGINNING_STOCK_EXPORT.SUCCESS, { lists }),
  failure: () => createAction(BEGINNING_STOCK_EXPORT.FAILURE),
}

function removeLists() {
  return {
    type: BEGINING_STOCK_REMOVE_LISTS,
  }
}

export {
  beginingStockLoadDivision,
  beginingStockLoadDepartment,
  beginingStockLoadSection,
  beginingStockLoadPlant,
  beginingStockLoadDataSourceForTable,
  beginingStockUpdateDataSourceForTable,
  beginingStockLoadError,
  removeLists,
  BEGINING_STOCK_REMOVE_LISTS,
  BEGINING_STOCK_LOAD_DIVISION,
  BEGINING_STOCK_LOAD_DEPARTMENT,
  BEGINING_STOCK_LOAD_SECTION,
  BEGINING_STOCK_LOAD_PLANT,
  BEGINING_STOCK_LOAD_DATASOURCE_FOR_TABLE,
  UPDATE_BEGINING_STOCK_DATASOURE_FOR_TABLE,
  BEGINING_STOCK_LOAD_ERROR,
  BEGINNING_STOCK_EXPORT,
  beginingStockExport,
}
